<template>
  <div class="global_config">
    <div class="flex_item">
      <div class="item_label">新版十路设备误拔断电时间：</div>
      <el-input-number
        v-model="wrongPullOutNum_v9.value"
        :min="3"
        :max="5"
      ></el-input-number>
      &nbsp;分钟
      <div class="save_btn">
        <el-button type="primary" @click="handleBreakpointErrorTimeBtnClick"
          >点击保存</el-button
        >
      </div>
    </div>
    <el-divider></el-divider>

    <div class="flex_item">
      <div class="item_label">禁用车辆审核：</div>
      <el-switch
        v-model="disableCarCheck.value"
        active-text="开"
        inactive-text="关"
        active-value="1"
        inactive-value="0"
      >
      </el-switch>
      <div class="save_btn">
        <el-button type="primary" @click="handleDisableCarCheckBtnClick"
          >点击保存</el-button
        >
      </div>
    </div>
    <el-divider></el-divider>
  </div>
</template>

<script>
import editConfigs from "@/api/common/agentEditConfigs";
import agentGetConfigs from "@/api/common/agentGetConfigs";
// import { Loading } from "element-ui";
export default {
  name: "globalConfig",
  data() {
    return {
      wrongPullOutNum_v9: {},
      disableCarCheck: {},
    };
  },
  created() {
    agentGetConfigs().then((res) => {
      this.wrongPullOutNum_v9 =
        res.data.find((r) => r.name == "wrongPullOutNum_v9") || {};

      this.disableCarCheck = res.data.find(
        (r) => r.name == "disableCarCheck"
      ) || { value: "1" };
    });
  },
  methods: {
    handleBreakpointErrorTimeBtnClick() {
      editConfigs({
        id: this.wrongPullOutNum_v9.id,
        value: this.wrongPullOutNum_v9.value,
      }).then((res) => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "保存成功~",
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    handleDisableCarCheckBtnClick() {
      editConfigs({
        id: this.disableCarCheck.id,
        value: this.disableCarCheck.value,
        remark: "禁用车辆审核",
        name: "disableCarCheck",
      }).then((res) => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "保存成功~",
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.global_config {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  box-sizing: border-box;
  padding: 10px;

  .flex_item {
    display: flex;
    align-items: center;
  }

  .save_btn {
    margin-left: 40px;
  }
}
</style>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .global_config {
    .flex_item {
      display: block;
      .item_label {
        margin-bottom: 10px;
      }
    }
    .save_btn {
      margin-left: 0;
      margin-top: 10px;
    }
  }
}
</style>
